import React, { useState, useEffect } from "react";
import ReportContentType from "../../enums/ReportContentType";
import { FB } from "../../assets/feedbackTheme";

//#region Options
const REPORT_TYPES = [
  { value: ReportContentType.BookSectionCrop, label: "Soru raporları" },
  { value: ReportContentType.AchievementVideo, label: "Kazanım video" },
  { value: ReportContentType.LectureSection, label: "Konu kartı" },
  { value: ReportContentType.AchievementVideoReaction, label: "Kazanım video tepkileri" },
];

const STATUS_OPTS = [
  { value: 0, label: "Açık" },
  { value: 1, label: "Çözülen" },
  { value: 2, label: "Tümü" },
];

const DATE_OPTS = [
  { value: 1, label: "Son 30 gün" },
  { value: 3, label: "Son 3 ay" },
  { value: 0, label: "Tüm zamanlar" },
];

const ORDER_OPTS = [
  { value: 1, label: "Sayıya göre" },
  { value: 0, label: "Tarihe göre" },
];
//#endregion

//#region Style
const styles = {
  container: {
    backgroundColor: FB.surface,
    padding: "10px 14px 12px",
    borderRadius: 12,
    boxShadow: "0 1px 3px 0 rgba(0,0,0,0.08)",
    border: `1px solid ${FB.border}`,
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },
  tabs: {
    display: "flex",
    gap: 22,
    borderBottom: `1px solid ${FB.border}`,
    marginBottom: 12,
    flexWrap: "wrap",
  },
  filterRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
  },
  groupLabel: { fontSize: 12, color: FB.textMuted },
  seg: {
    display: "inline-flex",
    border: `1px solid ${FB.border}`,
    borderRadius: 999,
    overflow: "hidden",
    backgroundColor: FB.surface,
  },
  divider: { width: 1, height: 22, backgroundColor: FB.border, margin: "0 2px" },
  cropInput: {
    height: 32,
    border: `1px solid ${FB.border}`,
    borderRadius: 8,
    padding: "0 10px",
    fontSize: 13,
    outline: "none",
    width: 150,
    color: FB.text,
  },
  cropBtn: {
    height: 32,
    border: "none",
    borderRadius: 8,
    padding: "0 14px",
    fontSize: 13,
    fontWeight: 500,
    cursor: "pointer",
    backgroundColor: FB.accent,
    color: "#fff",
  },
};

const tabStyle = (active) => ({
  fontSize: 14,
  padding: "8px 2px",
  background: "none",
  border: "none",
  borderBottom: active ? `2px solid ${FB.accent}` : "2px solid transparent",
  color: active ? FB.accent : FB.textSecondary,
  fontWeight: active ? 500 : 400,
  cursor: "pointer",
});

const segBtnStyle = (active, first) => ({
  fontSize: 13,
  padding: "6px 14px",
  border: "none",
  borderLeft: first ? "none" : `1px solid ${FB.border}`,
  background: active ? FB.accentSoft : "transparent",
  color: active ? FB.accent : FB.textSecondary,
  fontWeight: active ? 500 : 400,
  cursor: "pointer",
});
//#endregion

const FilterHeader = (props) => {
  // Defaults match FeedBacksPage state: Status 0 (Açık) + Son 30 gün + Sayıya göre.
  const [status, setStatus] = useState(0);
  const [dstatus, setdStatus] = useState(1);
  const [order, setOrder] = useState(1);
  const [cropStatus, setCropStatus] = useState("");
  const [reportType, setReportType] = useState(
    Number(sessionStorage.getItem("reportContentType")) || ReportContentType.BookSectionCrop
  );

  useEffect(() => {
    if (!props.cropId) setCropStatus("");
  }, [props.cropId]);

  const submitCrop = () => {
    if (cropStatus) {
      props.setCropId(cropStatus);
      props.setModal(cropStatus);
    } else {
      props.setCropId();
    }
  };

  const renderSegment = (opts, value, onPick) => (
    <div style={styles.seg}>
      {opts.map((o, i) => (
        <button
          key={o.value}
          onClick={() => onPick(o.value)}
          style={segBtnStyle(value === o.value, i === 0)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );

  return (
    <div style={styles.container}>
      <div style={styles.tabs}>
        {REPORT_TYPES.map((t) => (
          <button
            key={t.value}
            style={tabStyle(reportType === t.value)}
            onClick={() => {
              setReportType(t.value);
              props.setReportType(t.value);
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {reportType !== ReportContentType.AchievementVideoReaction && (
        <div style={styles.filterRow}>
          <span style={styles.groupLabel}>Durum</span>
          {renderSegment(STATUS_OPTS, status, (v) => {
            setStatus(v);
            props.setStatus(v);
          })}

          <span style={styles.divider} />
          <span style={styles.groupLabel}>Tarih</span>
          {renderSegment(DATE_OPTS, dstatus, (v) => {
            setdStatus(v);
            props.setdStatus(v);
          })}

          <span style={styles.divider} />
          <span style={styles.groupLabel}>Sırala</span>
          {renderSegment(ORDER_OPTS, order, (v) => {
            setOrder(v);
            props.setOrder(v);
          })}

          {reportType === ReportContentType.BookSectionCrop && (
            <>
              <span style={styles.divider} />
              <input
                style={styles.cropInput}
                type="text"
                placeholder="CropId ile aç"
                value={cropStatus}
                onChange={(e) => setCropStatus(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") submitCrop();
                }}
              />
              <button style={styles.cropBtn} onClick={submitCrop}>
                Aç
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterHeader;
